import request from '../utils/request'

export function isSign() {
    return request({
        url: '/api/sign/isSign',
        method: 'get'
    })
}

export function listByUser(data) {
    return request({
        url: '/api/sign/listByUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}


export function list(data) {
    return request({
        url: '/api/orderitem/list?order_no='+data.order_no+'&product_type='+data.product_type,
        method: 'get'
    })
}

export function add(data){
    return request({
        url: '/api/sign/add',
        method: 'post',
        data
    })
}

export function updateSelf(data){
    return request({
        url: '/api/orderitem/updateSelf',
        method: 'post',
        data
    })
}

export function user(data){
    return request({
        url: '/api/user/dev-api/system/user',
        method: 'get',
      
    })
}

export function listSelf(data){
    return request({
        url: '/api/profitJifen/listSelf?pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function getTeamsByUser(data){
    return request({
        url: '/api/user/getTeamsByUser',
        method: 'get'
    })
}

export function getSalesmanStat(data){
    return request({
        url: '/api/user/getSalesmanStat',
        method: 'get'
    })
}
export function listSubUser(data){
    return request({
        url: '/api/user/listSubUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function listSelfA(data){
    return request({
        url: '/api/orders/list_self',
        method: 'get',
        params: data
    })
}

export function listSelfB(data){
    return request({
        url: '/api/orders/listByCompany',
        method: 'get',
        params: data
    })
}

export function dictExpressList(data){
    return request({
        url: '/api/system/dict/data/type/express',
        method: 'get',
        params: data
    })
}

export function orderExpressAdd(data){
    return request({
        url: '/api/orderExpress/add',
        method: 'post',
        data
    })
}

export function changePayStatus(data){
    return request({
        url: '/api/orders/changePayStatus',
        method: 'post',
        data
    })
}

export function infoSelf(data){
    return request({
        url: '/api/orders/info_self?order_no='+data.order_no,
        method: 'get'
    })
}

export function infoByMainOrderNo(data){
    return request({
        url: '/api/orders/infoByMainOrderNo?main_order_no='+data.main_order_no,
        method: 'get'
    })
}

export function aftersalesAdd(data){
    return request({
        url: '/api/aftersales/add',
        method: 'post',
        data
    })
}

export function infoByUser(data){
    return request({
        url: '/api/aftersales/infoByUser?order_no='+data.order_no,
        method: 'get'
    })
}
export function remarkInfoByUser(data){
    return request({
        url: '/api/remark/infoByUser?order_no='+data.order_no+'&xcate='+data.xcate+'&xid='+data.xid+'&item_id='+data.item_id,
        method: 'get'
    })
}

export function cancelSelf(data){
    return request({
        url: '/api/orders/cancelSelf',
        method: 'post',
        data
    })
}
export function confirmSelf(data){
    return request({
        url: '/api/orders/confirmSelf',
        method: 'post',
        data
    })
}

export function buygoods(data){
    return request({
        url: '/api/orderitem/buygoods',
        method: 'post',
        data
    })
}

export function bookingListByUser(data){
    return request({
        url: '/api/booking/listByUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function bookingInfoByUser(data){
    return request({
        url: '/api/booking/infoByUser?id='+data.id,
        method: 'get'
    })
}

export function addressListByUser(data){
    return request({
        url: '/api/address/listByUser',
        method: 'get',
        params: data
    })
}

export function favListByUser(data){
    return request({
        url: '/api/fav/listByUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function InfoFavActive(data){
    return request({
        url: '/api/fav/infoByUser?xid='+data.xid+'&b_type='+data.b_type,
        method: 'get'
    })
}

export function addByUserFav(data){
    return request({
        url: '/api/fav/add',
        method: 'post',
        data
    })
}
export function deleteByUserFav(data){
    return request({
        url: '/api/fav/deleteByUser',
        method: 'post',
        data
    })
}

export function myApplyToCash(data){
    return request({
        url: '/api/myApplyToCash?vstoken='+data.vstoken+'&vsfrom='+data.vsfrom+'&mallToken='+data.mallToken+'&pageNo='+data.pageNo+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function BookingCancel(data){
    return request({
        url: '/api/booking/cancelSelf',
        method: 'post',
        data
    })
}

export function setdefault(data){
    return request({
        url: '/api/address/setdefault',
        method: 'post',
        data
    })
}

export function addressInfo(data){
    return request({
        url: '/api/address/info?id='+data.id,
        method: 'get'
    })
}

export function addressUpdate(data){
    return request({
        url: '/api/address/update',
        method: 'post',
        data
    })
}

export function addressAdd(data){
    return request({
        url: '/api/address/add',
        method: 'post',
        data
    })
}

export function addInvoiceAddress(data){
    return request({
        url: '/api/address/addInvoiceAddress',
        method: 'post',
        data
    })
}

export function addressDelete(data){
    return request({
        url: '/api/address/delete',
        method: 'post',
        data
    })
}

export function CardInfoByUser(data){
    return request({
        url: '/api/UserBankCard/infoByUser',
        method: 'get'
    })
}

export function CardUpdateUser(data){
    return request({
        url: '/api/UserBankCard/updateByUser',
        method: 'post',
        data
    })
}


export function orderOn(data){
    return request({
        url: '/api/orderitem/cart',
        method: 'get',
        params: data
    })
}

export function getDefAddress(data){
    return request({
        url: '/api/address/getDefAddress',
        method: 'get',
        params: data
    })
}

export function transferInfo(data){
    return request({
        url: '/api/transfer/info',
        method: 'get',
        params: data
    })
}

export function invoiceAdd(data){
    return request({
        url: '/api/invoice/add',
        method: 'post',
        data
    })
}

export function invoiceUpdate(data){
    return request({
        url: '/api/invoice/update',
        method: 'post',
        data
    })
}

export function invoiceSetdefault(data){
    return request({
        url: '/api/invoice/setdefault',
        method: 'post',
        data
    })
}

export function dictList(data){
    return request({
        url: '/api/system/dict/data/list',
        method: 'get',
        params: data
    })
}

export function invoiceDelete(data){
    return request({
        url: '/api/invoice/delete',
        method: 'post',
        data
    })
}

export function invoiceListByUser(data){
    return request({
        url: '/api/invoice/listByUser',
        method: 'get',
        params: data
    })
}

export function userInfo(data){
    return request({
        url: '/api/user/userInfo',
        method: 'get'
    })
}  

export function updateaddress(data){
    return request({
        url: '/api/orders/updateaddress',
        method: 'post',
        data
    })
}   

export function invoiceInfo(data){
    return request({
        url: '/api/invoice/info',
        method: 'get',
        params: data
    })
}


export function ordersSubmit(data){
    return request({
        url: '/api/orders/submit',
        method: 'post',
        data
    })
}

export function getPaystatus(data){
    return request({
        url: '/api/orders/paystatus?order_no='+data.order_no
    })
}

export function deleteCard(data){
    return request({
        url: '/api/orderitem/delete',
        method: 'post',
        data
    })
}

export function orderShare(data){
    return request({
        url: '/api/orderShare/add',
        method: 'post',
        data
    })
}